import { createContext } from 'react';
import { OmniverseConfig } from '../providers/ConfigProvider';

export const OmniverseConfigContext = createContext<OmniverseConfig>(
  {} as unknown as OmniverseConfig
);
